import { message } from 'antd';

import api from '@/api';

const ABORT_ERROR_CODE = 20;
let kyController = new AbortController();

const comparisonOfPeriodsModel = {
    name: 'comparisonOfPeriods',
    state: {
        data: null,
        columnData: null,
        firstPeriod: null,
        secondPeriod: null,
        periodDuration: 12,
        loading: false,
    },
    reducers: {
        setData(state, payload) {
            return {
                ...state,
                data: payload,
            };
        },
        setColumnData(state, payload) {
            return {
                ...state,
                columnData: payload,
            };
        },
        setLoading(state, payload) {
            return {
                ...state,
                loading: payload,
            };
        },
        setFirstPeriod(state, payload) {
            return {
                ...state,
                firstPeriod: payload,
            };
        },
        setSecondPeriod(state, payload) {
            return {
                ...state,
                secondPeriod: payload,
            };
        },
        setPeriodDuration(state, payload) {
            return {
                ...state,
                periodDuration: payload,
            };
        },
    },

    effects: () => ({
        cancelRequest() {
            kyController.abort();
            kyController = new AbortController();

            this.setLoading(false);
        },

        async fetchData(payload) {
            this.setLoading(true);
            this.setColumnData(null);
            try {
                const data = await api.miningAndPumping.fetchComparisonOfPeriods({
                    json: payload,
                    signal: kyController.signal,
                });

                if (Object.keys(data) < 1) {
                    message.info('Недостаточно данных для построения графика в режиме "Сравнение периодов"');
                } else {
                    this.setData(data);
                }
            } catch (error) {
                console.error(error);

                this.setData(null);
                if (error.code === ABORT_ERROR_CODE) return;
                if (error.response?.status === 400) {
                    try {
                        const errorData = await error.response.json();
                        const errorMsg = errorData?.error || 'Ошибка запроса (400)';
                        message.error(errorMsg);
                        console.error('400 Error Message:', errorMsg);
                    } catch (parseError) {
                        message.error('Ошибка 400. Не удалось прочитать сообщение.');
                        console.error('Failed to parse 400 response:', parseError);
                    }
                } else {
                    message.error('Не удалось получить данные для режима "Сравнение периодов"');
                }
            }
            this.setLoading(false);
        },
    }),

    selectors: (slice, createSelector) => ({
        tableColumns() {
            return createSelector(
                rootState => rootState.comparisonOfPeriods.data,
                rootState => rootState.summaryMode.summaryIndicators,
                (data, summaryIndicators) => {
                    const header = data?.header;
                    return summaryIndicators && header
                        ? header.map(item =>
                              summaryIndicators?.[item?.field] && item?.children
                                  ? {
                                        ...item,
                                        color: summaryIndicators?.[item?.field]?.color,
                                        children: item?.children.map(childItem => ({
                                            ...childItem,
                                            hide: !summaryIndicators?.[item?.field]?.tableChecked,
                                            valueFormatter: ({ value }) => (value?.toFixed ? value.toFixed(2) : value),
                                        })),
                                    }
                                  : item,
                          )
                        : [];
                },
            );
        },
    }),
};

export default comparisonOfPeriodsModel;
